module.exports = __webpack_public_path__ + "img/shopd.f5010d0a.png";